import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=2ba6212a&"
import script from "./TopNav.vue?vue&type=script&lang=ts&"
export * from "./TopNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports